import {PATHS} from '@/const';
import {langUtil} from '@/helper/lang';

const HTTP_WHITE_LIST = [];
// 非登录态不可访问页面，强行访问会主动跳转登录页
const NEED_LOGIN_PAGE_LIST = [
  PATHS.LOGOUT.pathname,
  PATHS.ACCOUNT_OVERVIEW.pathname,
  PATHS.ACCOUNT_VERIFICATION.pathname,
  PATHS.ACCOUNT_PREMIUM_CENTER.pathname,
  PATHS.ACCOUNT_SECURITY.pathname,
  PATHS.ACCOUNT_SECURITY_WITHDRAW_LIMIT.pathname,
  PATHS.ACCOUNT_SUB_ACCOUNTS.pathname,
  PATHS.ACCOUNT_API_MANAGEMENT.pathname,
  PATHS.ACCOUNT_SETTING.pathname,
  PATHS.ACCOUNT_FEEDBACK.pathname,
  PATHS.ACCOUNT_SECURITY_DEVICE_MANAGE.pathname,
  PATHS.ACCOUNT_SECURITY_DEVICE_HISTORY.pathname,
  PATHS.ACCOUNT_TAX_REPORTING.pathname,
  PATHS.SHARE_PREMIUM.pathname,
  PATHS.ASSETS_DEPOSIT.pathname,
  PATHS.ASSETS_DETAILS.pathname,
  PATHS.ASSETS_FUNDS.pathname,
  PATHS.ASSETS_ORDER_HISTORY.pathname,
  PATHS.ASSETS_OVERVIEW.pathname,
  PATHS.ASSETS_PNL_DETAILS.pathname,
  PATHS.ASSETS_SPOT_ORDER.pathname,
  PATHS.ASSETS_SPOT_TRADE.pathname,
  PATHS.ASSETS_SPOT_PNL_DETAILS.pathname,
  PATHS.ASSETS_TRADE_HISTORY.pathname,
  PATHS.ASSETS_WITHDRAWAL.pathname,
  PATHS.ASSETS_WITHDRAWAL_ADDRESS.pathname,
  PATHS.ASSETS_CONTRACT_ACCOUNT.pathname,
  PATHS.ASSETS_PILOT_CONTRACT_ACCOUNT.pathname,
  PATHS.ASSETS_SPOT_ACCOUNT.pathname,
  PATHS.ASSETS_INVESTMENT_ACCOUNT.pathname,
  PATHS.ASSETS_MARGIN_ACCOUNT.pathname,
  PATHS.ASSETS_TRADING_ACCOUNT.pathname,
  PATHS.ASSETS_FUND_ACCOUNT.pathname,
  PATHS.ASSETS_BORROWING_DETAILS.pathname,
  PATHS.ASSETS_ORDER_HISTORY_GROUP.pathname,
  PATHS.BUY_CRYPTO_PLACE_ORDER.pathname,
  PATHS.BIG_CLIENT_DASHBOARD.pathname,
  PATHS.EARN_ACTIVE.pathname,
  PATHS.ASSETS_TRANSFER.pathname,
  PATHS.EARN_MY_EARNINGS.pathname,
  PATHS.TRADER_HOME_FOLLOWER_VIEW.pathname,
  PATHS.TRADER_HOME.pathname,
  PATHS.COPIER_DETAIL.pathname,
  PATHS.ACTIVITY_REGISTER_REWARDS.pathname,
  PATHS.FIAT_WITHDRAW.pathname,
  PATHS.FIAT_WITHDRAW_ORDER_CONFIRM.pathname,
  PATHS.LEGEND_TRADING_BIND_CARD.pathname,
  PATHS.FIAT_DEPOSIT_TRANSFER_INFO.pathname,
  PATHS.LEGEND_TRADING_SYNC_KYC.pathname,
  PATHS.LEGEND_TRADING_WRITE_QUESTIONNAIRE.pathname,
  PATHS.FIAT_WITHDRAW_ORDER_RESULT.pathname,
  PATHS.LEGEND_TRADING_MANAGE_CARD.pathname,
  PATHS.ASSETS_FIAT_ACCOUNT.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_PAYMENT_METHOD.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_CONFIRM.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_RESULT.pathname,
  PATHS.FIAT_BUY_CRYPTO_BUY_CARD.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_CARD.pathname,
  PATHS.BUY_CRYPTO_CARD_DETAILS.pathname,
  PATHS.BUY_CRYPTO_CARD_SELL_CONFIRM.pathname,
  PATHS.BUY_CRYPTO_CARD_SELL_RESULT.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_PAYMENT_METHOD.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_CONFIRM.pathname,
  PATHS.FIAT_BUY_CRYPTO_SELL_RESULT.pathname,
  PATHS.BUY_CRYPTO_CARD_PAYMENT.pathname,
  PATHS.BUY_CRYPTO_CARD_ORDER_SUCCESS.pathname,
  PATHS.BUY_CRYPTO_CARD_ORDER_FAIL.pathname,
  PATHS.BUY_CRYPTO_CARD_HISTORY.pathname,
  PATHS.BUY_CRYPTO_CARD_ORDER_CONFIRM.pathname,
  PATHS.STRATEGY_DETAIL.pathname,
  PATHS.LEGEND_TRADING_BILLING_ADDRESS.pathname,
  PATHS.LEGEND_TRADING_CARD_BINDING.pathname,
  PATHS.LEGEND_TRADING_PAYMENT.pathname,
  PATHS.ASSETS_BUY_SELL_CRYPTO_HISTORY.pathname,
  PATHS.ASSETS_FIAT_DEPOSIT.pathname,
  PATHS.ASSETS_FIAT_WITHDRAW.pathname,
  PATHS.ACCOUNT_SECURITY_AUTHORIZATION_MANAGE.pathname,
  PATHS.WEB3_ASSETS_OVERVIEW.pathname,
  PATHS.ASSETS_SPOT_HISTORY.pathname,
  PATHS.ASSETS_MARGIN_HISTORY.pathname,
  PATHS.ASSETS_HISTORY.pathname,
  PATHS.BUY_CRYPTO_HISTORY.pathname,
  PATHS.COPY_TRADING_TRADER_SETTING.pathname,
  PATHS.WEB3_SOCIAL_TRADE_PT_REWARDS.pathname,
  PATHS.WEB3_SOCIAL_TRADE_MY_GROUPS.pathname,
  PATHS.WEB3_SOCIAL_TRADE_PULSE_PROFILE.pathname,
  PATHS.WEB3_SOCIAL_TRADE_INSCRIPTION_MARKETPLACE.pathname,
  PATHS.WEB3_SOCIAL_TRADE_PULSE_DROP.pathname,
  PATHS.ACCOUNT_PASSKEY_LIST.pathname,
  PATHS.ASSETS_TRANSFER_CONVERT_HISTORY.pathname,
  PATHS.ASSETS_DEPOSIT_WITHDRAW_HISTORY.pathname,
  PATHS.LAUNCHPAD_HISTORY.pathname,
];

const ADMIN_KOL_ROUTE_WHITE_LIST = [
  PATHS.KOL_HOME.pathname,
  PATHS.GENERALIZE.pathname,
  PATHS.MATERIAL.pathname,
  PATHS.INVITEE_COMMISSION.pathname,
  PATHS.SUB_AFFILIATE_COMMISSION.pathname,
  PATHS.PREMIUM.pathname,
  PATHS.ACCOUNTS.pathname,
  PATHS.AGENT_DEAL.pathname,
  PATHS.SUB_AGENT.pathname,
  PATHS.PERSONAL.pathname,
  PATHS.WITHDRAW.pathname,
];

export function withToken(apiUrl) {
  return HTTP_WHITE_LIST.indexOf(apiUrl) < 0;
}

export function withAdminKolToken(apiUrl) {
  return (!withAdminBrokerToken(apiUrl) && apiUrl.indexOf('phemex-kol-global') > 0) || apiUrl.indexOf('kol/agent') > 0;
}

export function withAdminBrokerToken(apiUrl) {
  return apiUrl.indexOf('/phemex-kol-global/broker/') >= 0;
}

export function shouldLogin(pathname) {
  const name = langUtil.parsePathname(pathname).pathname;
  return NEED_LOGIN_PAGE_LIST.indexOf(name) >= 0;
}

export function shouldAdminKolLogin(pathname) {
  const name = langUtil.parsePathname(pathname).pathname;
  return ADMIN_KOL_ROUTE_WHITE_LIST.indexOf(name) >= 0;
}
